import React, { Component } from 'react';
import { MessageCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
const PHONE_NUMBER = '2066193742';
const DEFAULT_MESSAGE = "Hi, I'm on your website and I have a question";
export function LiveChat() {
  const smsLink = `sms:${PHONE_NUMBER}?body=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  const location = useLocation();
  const isContractors = location.pathname.includes('subcontractors') || location.pathname.includes('contractors');
  const bgColor = isContractors ? 'bg-[#fbbf24] hover:bg-[#f59e0b]' : 'bg-[#1DB954] hover:bg-[#17A347]';
  const textColor = isContractors ? 'text-stone-900' : 'text-white';
  return <div className="hidden md:flex fixed bottom-5 left-5 z-50 flex-col items-start" data-id="element-896">
      <a href={smsLink} className={`shadow-md flex items-center justify-center transition-all hover:scale-105 ${bgColor} ${textColor} opacity-80 hover:opacity-100`} style={{
      width: 55,
      height: 36,
      borderRadius: 18
    }} aria-label="Text Us" data-id="element-897">
        <MessageCircle className="w-4 h-4" data-id="element-898" />
      </a>
    </div>;
}